import { PageHeader } from '@/components/common/PageHeader';
import { PageMeta } from '@/components/common/PageMeta';
import { GetStartedPage } from '@/pages/GetStarted/data';
import { ProjectRequestSection } from '@/pages/GetStarted/sections/ProjectRequestSection';

export default function GetStarted() {
  return (
    <>
      <PageMeta title={GetStartedPage.title} description={GetStartedPage.description} />
      <PageHeader title={GetStartedPage.heading} description={GetStartedPage.description} />
      <ProjectRequestSection />
    </>
  );
}